module.exports = __webpack_public_path__ + "static/media/noImage.87605475.png";